var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Loading',{attrs:{"active":_vm.show,"is-full-page":true,"loader":"spinner","background-color":"#121212","color":"#0000ff"},on:{"update:active":function($event){_vm.show=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }